import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/views/index'
Vue.use(VueRouter)

/**
 * Note: 路由配置项
 *
 * hidden: true                     // 当设置 true 的时候该路由不会再侧边栏出现 如401，login等页面，或者如一些编辑页面/edit/1
 * alwaysShow: true                 // 当你一个路由下面的 children 声明的路由大于1个时，自动会变成嵌套的模式--如组件页面
 *                                  // 只有一个时，会将那个子路由当做根路由显示在侧边栏--如引导页面
 *                                  // 若你想不管路由下面的 children 声明的个数都显示你的根路由
 *                                  // 你可以设置 alwaysShow: true，这样它就会忽略之前定义的规则，一直显示根路由
 * redirect: noRedirect             // 当设置 noRedirect 的时候该路由在面包屑导航中不可被点击
 * name:'router-name'               // 设定路由的名字，一定要填写不然使用<keep-alive>时会出现各种问题
 * query: '{"id": 1, "name": "ry"}' // 访问路由的默认传递参数
 * roles: ['admin', 'common']       // 访问路由的角色权限
 * permissions: ['a:a:a', 'b:b:b']  // 访问路由的菜单权限
 * meta : {
    noCache: true                   // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
    title: 'title'                  // 设置该路由在侧边栏和面包屑中展示的名字
    icon: 'svg-name'                // 设置该路由的图标，对应路径src/assets/icons/svg
    breadcrumb: false               // 如果设置为false，则不会在breadcrumb面包屑中显示
    activeMenu: '/system/user'      // 当路由设置了该属性，则会高亮相对应的侧边栏。
  }
 */

const RouterView = () => import('@/views/index')
const Login = () => import('@/views/LoginView.vue');//登录
const Register = () => import('@/views/Register.vue');//注册
const RegisterAccomplish = () => import('@/views/RegisterAccomplish.vue');//注册
const Home = () => import('@/views/HomeView.vue');//首页
const Default = ( )=> import('@/views/DefaultView.vue')//默认页面
const DataScreen = () => import('@/views/dataScreen/index.vue')//数据大屏

const UseCenter = () => import('@/views/InformationView.vue')//个人中心
const EndUser = () => import('@/views/MemberHome/EndUserView.vue')    // 终端用户
const PowerStation = () => import('@/views/Monitoring/PlanView.vue') //电站列表
const PowerStationInfo = () => import('@/views/Monitoring/plantInfo/plantInfo.vue')//电站详情
const HeatPowerStationInfo = () => import('@/views/Monitoring/heatPowerStationInfo/index.vue')//光热站详情
const DeviceInfo = () => import('@/views/device/deviceInfo/deviceInfo.vue') //设备详情
const InverterDeviceInfo = () => import('@/views/device/deviceInfo/inverterDeviceInfo.vue') //逆变器详情
const IotDeviceInfo = () => import('@/views/device/iotDeviceInfo/index.vue') //iot设备详情

// 设备列表
const Collector = () => import('@/views/Monitoring/DatalogView.vue')// 采集器列表
const Inverter = () => import('@/views/list/deviceView') //逆变器列表
const StoredEnergy = () => import('@/views/list/sotrageView') //储能列表
const Battery = () => import('@/views/list/batteryView') // 电池列表
const PowerSocket = () => import('@/views/list/socketView') // 插座列表

const Agent = () => import('@/views/MemberHome/AgentView.vue')//代理商列表
const ShipmentLog = () => import('@/views/MemberHome/ShipmentlogView.vue') // 出货日志
const FirmwareUpload = () => import('@/views/FirmwareView.vue') // 固件上传
const UpGradeRecord = () => import('@/views/Upgraderecord.vue') //升级记录
const CollectorLog = () => import('@/views/System/datalog_logsView.vue') //采集器日志
const OperationLog = () => import('@/views/System/logView.vue') //操作日志
const CommunicationLog = () => import('@/views/System/Specialsetting.vue') //通讯日志
const AppVersions = () => import('@/views/System/AppreleaseView.vue') //app版本
const AuthorityManagement = () => import('@/views/Limits/limits.vue')//权限管理
const MenuBar = () => import('@/views/Limits/menu.vue')//菜单栏
const DeviceList = () => import('@/views/device/deviceList.vue');//设备日列表

// const OrgManagement = () => import('@/views/orgManagement/orgManagement.vue');//组织管理
const Shipment = () => import('@/views/shipmentManagement/shipmentIndex.vue')    // 出货管理
const productManagements = () => import('@/views/productManagement/productList.vue');//产品管理
const productDetail = () => import('@/views/productManagement/productDetail.vue');//产品管理
const mutipleLanguage = () => import('@/views/productManagement/mutipleLanguage.vue');//多语言管理

const OrgManagement = () => import('@/views/orgManagement/orgManagement.vue');//组织管理
const deviceSeting = () => import('@/views/device/seting/deviceSeting.vue');//设备日列表

const userAgreement = () => import('@/views/word/userAgreement.vue');//用户协议
const privacyPolicy = () => import('@/views/word/privacyPolicy.vue');//隐私政策
const deviceManagement = () => import('@/views/deviceManagement/deviceIndex.vue');//设备管理

const i18nUpload = () => import('@/views/tools/i18nUpload.vue'); // * 上传国际化
const dictData = () => import('@/views/dictManage/dictData.vue');//字典数据
const Screen = () => import('@/views/screen/index.vue');//大屏

const advancedPreview = () => import('@/views/device/advancedFeatures/preview.vue');//高级功能预览
const physicalModelsDetail = () => import('@/views/physicalModels/detail.vue');//物理模型详情
// import index from '@/views/index.vue'
export const constantRoutes = [
  { path: '/i18nUpload', name: 'i18nUpload', component: i18nUpload, hidden: true},
  { path: '/login', name: 'login', component: Login, hidden: true, meta: { title: 'btn.login', icon: '', }, },
  { path: '/Register', name: 'Register', component: Register, hidden: true, meta: { title: 'button.register', icon: '', }, },
  { path: '/RegisterAccomplish', name: 'RegisterAccomplish', component: RegisterAccomplish, hidden: true, meta: { title: '注册完成', icon: '', }, },
  { path: '/userAgreement', name: 'userAgreement', component: userAgreement, hidden: true, meta: { title: 'title.userAgreement', icon: '', }, },
  { path: '/privacyPolicy', name: 'privacyPolicy', component: privacyPolicy, hidden: true, meta: { title: 'title.privacyPolicy', icon: '', }, },
  { path: '/', redirect: '/login', hidden: true, },
  { path: '/home', name: "default", component: DataScreen, 
    meta: { 
      title: 'system.dataScreen', 
      icon: 'icon-gongzuotai1',
      affix: true
    }, 
  },
  { path: '/information', name: "information", component: UseCenter, hidden: true, meta: { title: 'common.personalCenter', icon: '', }, },

  // 电站管理
  { path: '/device/deviceInfo/:deviceTypeCode/:deviceSn', name: 'deviceInfo', component: DeviceInfo, hidden: true, meta: { title: 'subtitle.deviceDetails', activeMenu: '/powerStation' } },
  
  { path: '/404', component: () => import('@/views/errorPage/404.vue'), hidden: true },
]

// 动态路由，基于用户权限动态去加载
export const dynamicRoutes = [
  {
    path: '/diagnosis/ivlineCreate',
    component: Layout,
    hidden: true,
    permissions: ['ivline:main:index'],
    children: [
      {
        path: 'index',
        component: () => import('@/views/intelligentDiagnosis/ivlineCreate.vue'),
        name: 'ivlineCreate',
        meta: { title: 'subtitle.ivlineCreate', activeMenu: '/diagnosis/ivline' }
      }
    ]
  },
  // 产品管理-产品详情
  {
    path: '/productDetail/:dtc', 
    name: 'productDetail', 
    icon: 'icon-dianzhangaikuang', 
    component: productDetail, 
    meta: { title: 'common.productDetail', icon: 'icon-dianzhangaikuang', activeMenu: '/productManagements' },
    hidden: true,
    permissions: ['product:list:detailSet'], 
  },
  // 产品管理-物模型多语言
  {
    path: '/productManagements/mutipleLanguage/:id/:deviceType?', 
    name: 'mutipleLanguage', 
    icon: 'icon-dianzhangaikuang', 
    component: mutipleLanguage, 
    meta: { title: 'product.multipleLanguage', icon: 'icon-dianzhangaikuang', activeMenu: '/productManagements' },
    hidden: true,
    permissions: ['product:list:mutipleLanguage'], 
  },
  // 电站管理-电站详情
  { 
    path: '/powerStation/powerStationInfo/:id', 
    name: 'powerStationInfo', 
    component: PowerStationInfo, 
    hidden: true, 
    meta: { title: 'product.PlantDetails', activeMenu: '/powerStation' },
    permissions: ['plant:list:plantName'],
  },
  // 光热站详情页
  { 
    path: '/powerStation/heatPowerStationInfo/:id', 
    name: 'heatPowerStationInfo', 
    component: HeatPowerStationInfo, 
    hidden: true, 
    meta: { title: 'product.PlantDetails', activeMenu: '/powerStation' },
    permissions: ['plant:list:plantName'],
  },
  // 电站大屏页
  {
    path: '/screen/:id', 
    name: 'screen', 
    component: Screen, 
    hidden: true, 
    meta: { title: 'plant.MonitoringScreen', icon: '', },  
    permissions: ['plant:list:screen'], 
  },
  // 设备管理-设备详情
  { 
    path: '/device/seting/:deviceType/:deviceSn', 
    name: "deviceSeting", 
    component: deviceSeting, 
    hidden: true, 
    meta: { title: 'common.deviceSet', icon: '', activeMenu: '/deviceManagement' }, 
    permissions: ['device:list:snClick'], 
  },
  // 设备管理-逆变器详情
  { 
    path: '/device/inverterDeviceInfo/:accessPlatForm?/:plantId?/:productId?/:timeZone?/:deviceType/:deviceSn', 
    name: 'inverterDeviceInfo', 
    component: InverterDeviceInfo, 
    hidden: true, 
    meta: { title: 'subtitle.deviceDetails', activeMenu: '/deviceManagement' },
    permissions: ['device:list:snClick'], 
  },
  // 设备管理-物联网设备详情
  { 
    path: '/device/iotDeviceInfo/:datalogSn?/:accessPlatForm?/:plantId?/:productId?/:timeZone?/:deviceType/:deviceSn', 
    name: 'iotDeviceInfo', 
    component: IotDeviceInfo, 
    hidden: true, 
    meta: { title: 'subtitle.deviceDetails', activeMenu: '/deviceManagement' },
    permissions: ['device:list:snClick'], 
  },
  // 设备管理-高级功能预览
  { 
    path: '/device/advancedFeatures/preview/:accessPlatform/:deviceType/:id/:deviceSn?', 
    name: 'advancedPreview', 
    component: advancedPreview, 
    hidden: true, 
    meta: { title: 'subtitle.advancedPreview', activeMenu: '/deviceManagement' },
    permissions: ['physicalModels:functionSet:preview'], 
  },
  // 字典管理-二级页面
  { 
    path: '/dictManage/dictData/:id?/:dictnameen?/:dictname?', 
    name: 'dictData', 
    component: dictData, 
    hidden: true, 
    meta: { title: 'subtitle.dictData', activeMenu: '/dictManage' },
    permissions: ['dictManage:list:secondaryPage'], 
  },
  // 物模型管理-details
  { 
    path: '/physicalModels/detail/:deviceType/:accessPlatform',
    name: 'physicalModelsDetail', 
    component: physicalModelsDetail, 
    hidden: true, 
    meta: { title: 'subtitle.physicalModelsDetail', activeMenu: '/physicalModels' },
    permissions: ['physicalModels:list:detail'], 
  },
]

// 防止连续点击多次路由报错
let routerPush = VueRouter.prototype.push;
let routerReplace = VueRouter.prototype.replace;
// push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}
// replace
VueRouter.prototype.replace = function push(location) {
  return routerReplace.call(this, location).catch(err => err)
}

export default new VueRouter({
  mode: 'history', // 去掉url中的#
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})
